export default "__VITE_ASSET__YyOTapXJ__"